
import { Component, Model, Vue, Prop, Watch } from "vue-property-decorator";

interface IListViewItem<T> {
  Value: T;
  Selected: boolean;
  Disabled: boolean;
}

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-usable-dropdown"
})
export default class UiUsableDropdownComponent extends Vue {
  @Prop({ default: () => [], type: Array}) items!: any[];
  @Prop({ default: 'id', type: String}) keyField: string;
  @Prop({ default: false, type: Boolean}) autocomplete: boolean;
  @Prop({ default: false, type: Boolean}) scroll: boolean;
  @Prop({ default: false, type: Boolean}) multiselect: boolean;
  @Prop({ default: false, type: Boolean}) required: boolean;
  @Prop({ default: () => [] as string[]}) nameFields: string[];
  @Model('onSelected', {type: [String, Number, Boolean, Object, Array]}) value: any | string | number | boolean;
  dropdownItems: Array<IListViewItem<any>> = new Array<IListViewItem<any>>();
  @Watch('dropdownItems', { deep: true })
  onDropdownListChanged(value: IListViewItem<any> | IListViewItem<any>[]) {
    this.emitSelectedItems(Array.isArray(value) ? value.filter(x => x.Selected) : [value]);
  }
  onDropdownChanged(items: IListViewItem<any>[]) {
    this.emitSelectedItems(items || []);
  }
  emitSelectedItems(items: IListViewItem<any>[]) {
    const result = (items || []).map(x => this.getListViewValue(x));
    if (result.length == 0) {
      this.$emit('onSelected', null);
      return;
    }
    this.$emit('onSelected', result.length == 1 && !this.multiselect ? result[0] : result);
  }
  getValue(value: any): any {
    if (!(value as Object).hasOwnProperty(this.keyField)) {
      console.warn(`Объект ${value} не имеет поля ${this.keyField}`);
    }
    return value[this.keyField];
  }
  getListViewValue(value: IListViewItem<any>): any {
    return value && value.Value ? this.getValue(value.Value) : null;
  }
  getString(value: any): any {
    let name = '';
    this.nameFields.forEach(nameField => {
      if (!(value as Object).hasOwnProperty(nameField)) {
        console.warn(`Объект ${value} не имеет поля ${nameField}`);
      } else {
        name = name + (value as any)[nameField] + ' '
      }
    });
    return name;
  }
  @Watch('value')
  onValueChanged() {
    this.dropdownItems.forEach(item => {
      item.Selected = this.multiselect ? (this.value || []).indexOf(this.getValue(item.Value)) != -1 :
       this.value == this.getValue(item.Value)
    })
  }
  @Watch('items') 
  onItemsChanged()
  {
    this.initDdItems();
    this.sourceListItem = this.dropdownItems;
  }
  toListViewItem(item: any): IListViewItem<any> {
    const isSelected = this.multiselect ? (this.value || []).indexOf(this.getValue(item)) != -1 :
       this.value == this.getValue(item);
    const displayValue = Object.assign({}, item, {
      Equal: (object: any): boolean => this.getValue(item) == this.getValue(object),
      EqualRelation: (object: any): boolean => this.getValue(item) == this.getValue(object),
      ToString: (): string => this.getString(item),
    });
    const result: IListViewItem<any> = {
      Value: displayValue,
      Selected: isSelected,
      Disabled: false,
    };
    return result;
  }
  initDdItems() {
    this.dropdownItems = (this.items || []).map(x=>this.toListViewItem(x));
  }
  sourceListItem: Array<IListViewItem<any>> = [];
  created() {
    this.initDdItems();
    this.sourceListItem = this.dropdownItems;

  }
  changeAutocomlite(search: string) {
    this.dropdownItems = this.sourceListItem.filter(item => (item.Value as any)[this.nameFields[0]].toLowerCase().indexOf(search.toLowerCase()) != -1);
  }
}
